import { Box, Button } from '@mui/material';
import styled from 'styled-components';

export const SearchInputWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  '@media (max-width: 778px)': {
    flexDirection: 'column',
    gap: '12px'
  }
}));

export const ButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
  gap: 16,
  width: '100%',
  '@media (max-width: 600px)': {
    flexDirection: 'column'
  }
}));

export const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  width: '100%',
  borderRadius: '8px !important',
  textWrap: 'nowrap',
  marginTop: 0,
  '@media (min-width: 600px)': {
    width: 'max-content !important',
    marginTop: '30px !important'
  }
});
